import * as React from "react";
import coat from "./../../../../resources/img/bibi_na_bwana.png"
import {getCurrentTimestamp} from './../../../../utils'

export default class BillDetails extends React.Component {

    constructor(props) {
        super(props);
        this.reportTemplateRef = React.createRef();
        this.state = {}
    }

    componentDidMount() {
        console.log('FF : ' + this.props.projects)
    }

    render() {
        const converter = require('number-to-words');
        return (
            <>
                <div className={"row"} style={{width: '100%', margin: '2%', marginBottom: '0%'}}>

                    <div className={"row"}>
                        <div style={{
                            overflowX: 'hidden',
                            overflowY: 'auto',
                            border: 'lightgray',
                            backgroundColor: 'white',
                            borderStyle: 'solid',
                            padding: '0px',
                            paddingBottom:'8%',
                            width : '40.5%'
                        }} className={'col col-sm-8'}>
                            <center className={"row"}
                                    style={{fontSize: '10px', padding: '10px', paddingTop: '15px', color: '#335273'}}>
                                <div style={{textAlign: "center", height: "fit-content"}}><img
                                    style={{width: '10%', height: '45%'}} src={coat}/></div>
                                <div>United Republic Of Tanzania</div>
                                <div><b>National Land Use Planning Commission</b></div>
                                <div>Government Bill</div>
                            </center>
                            <center>
                                <hr style={{
                                    borderTop: '1px dashed #aaabaf',
                                    color: '#fff',
                                    backgroundColor: '#fff',
                                    height: '1px',
                                    width: '85%'
                                }} className={"row"}></hr>
                            </center>
                            <div className={"row"}>
                                <div className={'col col-sm-8'} style={{fontSize: '9px'}}>
                                    <div>
                                        <div style={{padding: '4px', paddingLeft: '6%'}} className={"row"}>
                                            <div className={'col col-sm-1'}></div>
                                            <div className={'col col-sm-4'}>
                                                <span>Control Number</span>
                                            </div>
                                            <div className={'col col-sm-4'}>
                                                <span><b>{': ' + this.props.projects[0].project.name}</b></span>
                                            </div>
                                        </div>
                                        <div style={{padding: '4px', paddingLeft: '6%'}} className={"row"}>
                                            <div className={'col col-sm-1'}></div>
                                            <div className={'col col-sm-4'}>
                                                <span>Payment Ref</span>
                                            </div>
                                            <div className={'col col-sm-4'}>
                                                <span><b>: Sales of Map</b></span>
                                            </div>
                                        </div>
                                        <div style={{padding: '4px', paddingLeft: '6%'}} className={"row"}>
                                            <div className={'col col-sm-1'}></div>
                                            <div className={'col col-sm-4'}>
                                                <span>Service Provider Code</span>
                                            </div>
                                            <div className={'col col-sm-4'}>
                                                <span><b>: SP120</b></span>
                                            </div>
                                        </div>
                                        <div style={{padding: '4px', paddingLeft: '6%'}} className={"row"}>
                                            <div className={'col col-sm-1'}></div>
                                            <div className={'col col-sm-4'}>
                                                <span>Payer Name</span>
                                            </div>
                                            <div className={'col col-sm-4'}>
                                                <span>: Ugali Mwaisa</span>
                                            </div>
                                        </div>
                                        <div style={{padding: '4px', paddingLeft: '6%'}} className={"row"}>
                                            <div className={'col col-sm-1'}></div>
                                            <div className={'col col-sm-4'}>
                                                <span>Payer Phone</span>
                                            </div>
                                            <div className={'col col-sm-4'}>
                                                <span>: 0674913992</span>
                                            </div>
                                        </div>
                                        <div style={{padding: '4px', paddingLeft: '6%'}} className={"row"}>
                                            <div className={'col col-sm-1'}></div>
                                            <div className={'col col-sm-4'}>
                                                <span>Bill Description</span>
                                            </div>
                                            <div className={'col col-sm-4'}>
                                                <span>: Sales of Map</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <center>
                                <hr style={{
                                    borderTop: '1px solid lightgray',
                                    color: '#fff',
                                    backgroundColor: '#fff',
                                    height: '1px',
                                    width: '85%'
                                }} className={"row"}></hr>
                            </center>
                            <div className={"row"}>
                                <div className={'col col-sm-12'} style={{fontSize: '9px'}}>
                                    {
                                        this.props.projects.map((d, i) => {
                                            return (<div>
                                                <div style={{padding: '4px', paddingLeft: '6%'}} className={"row"} key={i}>
                                                    <div className={'col col-sm-2'} style={{marginLeft: '2.7%'}}>
                                                        <span>Bill Item ({i + 1})</span>
                                                    </div>
                                                    <div className={'col col-sm-5'} style={{marginLeft: '5.5%'}}>
                                                        <span>{': ' + d.project.name}</span>
                                                    </div>
                                                    <div className={'col col-sm-2'}
                                                         style={{marginLeft: '5.5%'}}>
                                                        : {Number(d.fee.price).toLocaleString('en-US', {maximumFractionDigits:2}) + '.00'}</div>
                                                </div>
                                            </div>)
                                        })
                                    }
                                </div>
                            </div>
                            <center>
                                <hr style={{
                                    borderTop: '1px solid lightgray',
                                    color: '#fff',
                                    backgroundColor: '#fff',
                                    height: '1px',
                                    width: '85%'
                                }} className={"row"}></hr>
                            </center>

                            <div className={"row"}>
                                <div className={'col col-sm-12'} style={{fontSize: '9px'}}>
                                    <div>
                                        <div style={{padding: '4px', paddingLeft: '6%'}} className={"row"}>
                                            <div className={'col col-sm-2'} style={{marginLeft: '2.7%'}}>
                                            </div>
                                            <div className={'col col-sm-4'} style={{marginLeft: '5.5%'}}>
                                                <span><b>Total Billed Amount</b></span>
                                            </div>
                                            <div className={'col col-sm-3'}
                                                 style={{marginLeft: '5%'}}><b>
                                                : {Number(this.props.checkout_total).toLocaleString('en-US', {maximumFractionDigits:2}) + '.00 ('
                                                 + 'TZS)'}</b></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"row"}>
                                <div className={'col col-sm-8'} style={{fontSize: '9px'}}>
                                    <div>
                                        <div style={{padding: '4px', paddingLeft: '6%'}} className={"row"}>
                                            <div className={'col col-sm-1'}></div>
                                            <div className={'col col-sm-4'}>
                                                <span>Amount In Words</span>
                                            </div>
                                            <div className={'col col-sm-6'} style={{textTransform: "capitalize"}}>
                                                <span><b>{': ' + converter.toWords(Number(this.props.checkout_total))
                                                    + ' ' + this.props.projects[0].fee.currency_name}</b></span>
                                            </div>
                                        </div>
                                        <div style={{padding: '4px', paddingLeft: '6%'}} className={"row"}>
                                            <div className={'col col-sm-1'}></div>
                                            <div className={'col col-sm-4'}>
                                                <span>Expires On</span>
                                            </div>
                                            <div className={'col col-sm-4'}>
                                                <span>: 20-Jun-2023</span>
                                            </div>
                                        </div>
                                        <div style={{padding: '4px', paddingLeft: '6%'}} className={"row"}>
                                            <div className={'col col-sm-1'}></div>
                                            <div className={'col col-sm-4'}>
                                                <span>Prepared By</span>
                                            </div>
                                            <div className={'col col-sm-4'}>
                                                <span><b>: Stakeholder Name</b></span>
                                            </div>
                                        </div>
                                        <div style={{padding: '4px', paddingLeft: '6%'}} className={"row"}>
                                            <div className={'col col-sm-1'}></div>
                                            <div className={'col col-sm-4'}>
                                                <span>Printed By</span>
                                            </div>
                                            <div className={'col col-sm-4'}>
                                                <span>: Stakeholder Name</span>
                                            </div>
                                        </div>
                                        <div style={{padding: '4px', paddingLeft: '6%'}} className={"row"}>
                                            <div className={'col col-sm-1'}></div>
                                            <div className={'col col-sm-4'}>
                                                <span>Printed On</span>
                                            </div>
                                            <div className={'col col-sm-4'}>
                                                <span>: {getCurrentTimestamp("DD-MMM-YYYY")}</span>
                                            </div>
                                        </div>
                                        <div style={{padding: '4px', paddingLeft: '6%'}} className={"row"}>
                                            <div className={'col col-sm-1'}></div>
                                            <div className={'col col-sm-4'}>
                                                <span>Signature</span>
                                            </div>
                                            <div className={'col col-sm-4'}>
                                                <span>: ......................................</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>


                            <div className={"row"}>
                                <div className={'col col-sm-12'} style={{fontSize: '9px'}}>
                                    <div>
                                        <div style={{padding: '4px', paddingLeft: '0%' ,paddingBottom: '0px'}} className={"row"}>
                                            <div className={'col col-sm-1'}></div>
                                            <div className={'col col-sm-5'}>
                                                <span><b>Jinsi ya kulipa</b></span>
                                            </div>
                                            <div className={'col col-sm-5'}>
                                                <span><b>How to Pay</b></span>
                                            </div>
                                        </div>
                                        <div style={{padding: '4px', paddingLeft: '0%',paddingBottom: '0px', lineHeight:'15px'}} className={"row"}>
                                            <div className={'col col-sm-1'}></div>
                                            <div className={'col col-sm-5'}>
                                                <span>1. Kupitia Benki: Fika tawi lolote au wakala wa benki ya CRDB,
                                                    NMB, BOT. Namba ya Kumbukumbu <b>{this.props.projects[0].project.name}</b>
                                                </span><br/>
                                                <span>2. Kupitia Mitandao ya Simu: <br/>
                                                    <ul style={{marginTop:'0px', marginLeft: '-20px'}}>
                                                        <li>Ingia kwenye menyu ya mtandao husika</li>
                                                        <li>Chagua 4 (Lipa Bili)</li>
                                                        <li>Chagua 5 (Malipo ya Serikali)</li>
                                                        <li>Ingiza <b>{this.props.projects[0].project.name}</b> kama namba ya kumbukumbu</li>
                                                    </ul>
                                                </span>
                                            </div>
                                            <div className={'col col-sm-5'}>
                                                <span>1. Via Bank: Visit any branch or bank agent of CRDB,
                                                    NMB, BOT. Reference Number <b>{this.props.projects[0].project.name}</b>
                                                </span><br/>
                                                <span>2. Via Mobile Network Operators (MNO): <br/>
                                                    <ul style={{marginTop:'0px', marginLeft: '-20px'}}>
                                                        <li>Enter to the respective USSD Menu of the MNO</li>
                                                        <li>Select 4 (Make Payments)</li>
                                                        <li>Select 5 (Government Payments)</li>
                                                        <li>Enter <b>{this.props.projects[0].project.name}</b> sa a reference number</li>
                                                    </ul>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </>
        )
    }
}